import Class from './c-content-chart-budget';
import './c-content-chart-budget@.vue';

export default Class;